import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Container} from "mdbreact";
import {Link} from "react-router-dom";

const pageTitle = "راهنمای سایت";

export default class Sitemap extends Component {
    render() {
        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white mt-3 rtl'>
                            <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                            <BreadcrumbItem active>{pageTitle}</BreadcrumbItem>
                    </Breadcrumb>

                    <div className="white p-3 rtl">
                        <h3>{pageTitle}</h3>
                        <p>
                            <ul className="list-group sitemap mt-4 mb-3">
                                <li className="list-group-item"><Link to='/'>صفحه نخست</Link></li>
                                <li className="list-group-item"><Link to='/merchantList'> کسب و کارها</Link></li>
                                <li className="list-group-item"><Link to='/contact-us'>تماس با ما</Link></li>
                                <li className="list-group-item"><Link to='/about'>درباره ما</Link></li>
                                <li className="list-group-item"><Link to='/login'>ورود کاربران</Link></li>
                                <li className="list-group-item"><Link to='/business'>کسب و کار</Link></li>
                                <li className="list-group-item"><Link to='/merchant-partners'>همکاران تجاری</Link></li>
                                <li className="list-group-item"><Link to='/careers'>فرصت های شغلی</Link></li>

                                <li className="list-group-item"><Link to='/licences'>مجوزها</Link></li>
                                <li className="list-group-item"><Link to='/terms-of-use'>شرایط استفاده</Link></li>
                                <li className="list-group-item"><Link to='/privacy-policy'>حریم خصوصی</Link></li>
                                <li className="list-group-item"><Link to='/hotel-rules'>قوانین استفاده</Link></li>
                                <li className="list-group-item"><Link to='/how-it-works' >سوالات متداول</Link></li>
                                <li className="list-group-item active"><Link to='/sitemap' >راهنمای سایت</Link></li>

                            </ul>
                        </p>

                    </div>
                </Container>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Sitemap.js